import React from "react";
import { Spinner } from "@chakra-ui/spinner";

const SubaccountDropdown = ({
  isDisabled,
  newUser,
  handleInputChange,
  merchants,
  subaccounts,
  isSetSubaccounts,
}: any) => {
  const handleOptionClick = (event: React.ChangeEvent<HTMLSelectElement>) => {
    handleInputChange({
      target: { name: "subaccount", value: event.target.value },
    });
  };

  return (
    <div>
      <select
        id="subaccount"
        name="subaccount"
        value={newUser.subaccount}
        onChange={handleOptionClick}
        className="custom-select relative h-10 w-full rounded-md  border border-gray-300 bg-white py-2 pl-3 pr-10 text-sm font-medium text-navy-700 shadow-sm focus:outline-none sm:text-sm"
        disabled={
          isSetSubaccounts ||
          subaccounts === null ||
          subaccounts.length === 0 ||
          isDisabled
        }
      >
        {isSetSubaccounts || !merchants ? (
          <option>Retreiving...</option>
        ) : subaccounts.length === 0 ? (
          <option>-- Please Select --</option>
        ) : (
          <>
            {subaccounts.map((subaccount: any) => (
              <option key={subaccount.id} value={subaccount.id}>
                {subaccount.suba_name}
              </option>
            ))}
          </>
        )}
      </select>
      {!subaccounts && (
        <div className="mt-2 flex justify-center">
          <Spinner size="sm" />
        </div>
      )}
    </div>
  );
};

export default SubaccountDropdown;
